import EssentialData from "private/classes/EssentialData.class";

export class BaseSeoAdapter {
  constructor(public readonly essentialData: EssentialData) {
    this.essentialData = essentialData;
  }
}
